export var OWL_NATIVE_DATE_TIME_FORMATS = {
    parseInput: null,
    fullPickerInput: { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' },
    datePickerInput: { year: 'numeric', month: 'numeric', day: 'numeric' },
    timePickerInput: { hour: 'numeric', minute: 'numeric' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-pick-datetime/date-time/adapter/native-date-time-format.class.js
// module id = ./node_modules/ng-pick-datetime/date-time/adapter/native-date-time-format.class.js
// module chunks = vendor